import React from 'react'

import Header from './sections/Header'
import Separator from '../../../../components/pdf/Separator'
import Footer from './sections/Footer'
import Contacts from './sections/Contacts'
import Summaries from './sections/Summaries'
import PaymentSummary from './sections/PaymentSummary'
import Pricing from './sections/Pricing'
import DeliverySchedules from './sections/DeliverySchedules'
import ShippingLocations from './sections/ShippingLocations'
import PaymentDetails from './sections/PaymentDetails'
import { useReplies } from '../_load/ServiceOrderLoader'
import {
  filterRepliesByParentReference,
  findReplyByQuestionId,
  getRepliesFromBlockQuestion,
  getReplyValue
} from '../_helpers/pdfHelpers'

const PropostaComercialPageContent = () => {
  const replies = useReplies()

  const hardwareBlock = () => {
    const blockReply = findReplyByQuestionId(replies, 342)
    const hardwareReplies = filterRepliesByParentReference(replies, blockReply?.question?.reference)

    const hardwareResult = {}
    hardwareReplies.forEach(hardwareReply => {
      const blockIndex = hardwareReply.blockIndex
      let hardwareData = hardwareResult[blockIndex]
      if (!hardwareData) {
        const blockReplies = getRepliesFromBlockQuestion(hardwareReplies, blockIndex)
        const quantity = getReplyValue(findReplyByQuestionId(blockReplies, 345))
        const term = getReplyValue(findReplyByQuestionId(blockReplies, 346))
        const listPrice = getReplyValue(findReplyByQuestionId(blockReplies, 347))
        const tax = getReplyValue(findReplyByQuestionId(blockReplies, 350))
        const taxValue = tax ? tax : 1
        const termValue = term ? term : 1
        const subtotal = quantity * termValue * listPrice
        const total = subtotal * taxValue

        hardwareData = {
          item: getReplyValue(findReplyByQuestionId(blockReplies, 343)),
          description: getReplyValue(findReplyByQuestionId(blockReplies, 344)),
          quantity,
          term,
          listPrice,
          netPrice: getReplyValue(findReplyByQuestionId(blockReplies, 348)),
          subtotal,
          tax,
          bundle: getReplyValue(findReplyByQuestionId(blockReplies, 352)),
          shippingLocation: getReplyValue(findReplyByQuestionId(blockReplies, 356)),
          estimatedDeliveryDate: getReplyValue(findReplyByQuestionId(blockReplies, 357)),
          estimatedStartDate: getReplyValue(findReplyByQuestionId(blockReplies, 364)),
          estimatedEndDate: getReplyValue(findReplyByQuestionId(blockReplies, 365)),
          invoicePlan: getReplyValue(findReplyByQuestionId(blockReplies, 387)),
          unbundled: getReplyValue(findReplyByQuestionId(blockReplies, 433)),
          total
        }
        hardwareResult[blockIndex] = hardwareData
      }
    })
    return Object.values(hardwareResult)
  }

  const softwareBlock = () => {
    const blockReply = findReplyByQuestionId(replies, 403)
    const softwareReplies = filterRepliesByParentReference(replies, blockReply?.question?.reference)

    const softwareResult = {}
    softwareReplies.forEach(softwareReply => {
      const blockIndex = softwareReply.blockIndex
      let softwareData = softwareResult[blockIndex]
      if (!softwareData) {
        const blockReplies = getRepliesFromBlockQuestion(softwareReplies, blockIndex)
        const quantity = getReplyValue(findReplyByQuestionId(blockReplies, 406))
        const term = getReplyValue(findReplyByQuestionId(blockReplies, 407))
        const listPrice = getReplyValue(findReplyByQuestionId(blockReplies, 408))
        const tax = getReplyValue(findReplyByQuestionId(blockReplies, 411))
        const taxValue = tax ? tax : 1
        const termValue = term ? term : 1
        const subtotal = quantity * termValue * listPrice
        const total = subtotal * taxValue

        softwareData = {
          item: getReplyValue(findReplyByQuestionId(blockReplies, 404)),
          description: getReplyValue(findReplyByQuestionId(blockReplies, 405)),
          quantity,
          term,
          listPrice,
          netPrice: getReplyValue(findReplyByQuestionId(blockReplies, 409)),
          subtotal,
          tax,
          bundle: getReplyValue(findReplyByQuestionId(blockReplies, 412)),
          shippingLocation: getReplyValue(findReplyByQuestionId(blockReplies, 413)),
          estimatedDeliveryDate: getReplyValue(findReplyByQuestionId(blockReplies, 414)),
          estimatedStartDate: getReplyValue(findReplyByQuestionId(blockReplies, 415)),
          estimatedEndDate: getReplyValue(findReplyByQuestionId(blockReplies, 416)),
          invoicePlan: getReplyValue(findReplyByQuestionId(blockReplies, 417)),
          unbundled: getReplyValue(findReplyByQuestionId(blockReplies, 434)),
          total
        }
        softwareResult[blockIndex] = softwareData
      }
    })
    return Object.values(softwareResult)
  }

  const servicesBlock = () => {
    const blockReply = findReplyByQuestionId(replies, 418)
    const servicesReplies = filterRepliesByParentReference(replies, blockReply?.question?.reference)

    const servicesResult = {}
    servicesReplies.forEach(servicesReply => {
      const blockIndex = servicesReply.blockIndex
      let servicesData = servicesResult[blockIndex]
      if (!servicesData) {
        const blockReplies = getRepliesFromBlockQuestion(servicesReplies, blockIndex)
        const quantity = getReplyValue(findReplyByQuestionId(blockReplies, 421))
        const term = getReplyValue(findReplyByQuestionId(blockReplies, 422))
        const listPrice = getReplyValue(findReplyByQuestionId(blockReplies, 423))
        const tax = getReplyValue(findReplyByQuestionId(blockReplies, 426))
        const taxValue = tax ? tax : 1
        const termValue = term ? term : 1
        const subtotal = quantity * termValue * listPrice
        const total = subtotal * taxValue

        servicesData = {
          item: getReplyValue(findReplyByQuestionId(blockReplies, 419)),
          description: getReplyValue(findReplyByQuestionId(blockReplies, 420)),
          quantity,
          term,
          listPrice,
          netPrice: getReplyValue(findReplyByQuestionId(blockReplies, 409)),
          subtotal,
          tax,
          bundle: getReplyValue(findReplyByQuestionId(blockReplies, 427)),
          shippingLocation: getReplyValue(findReplyByQuestionId(blockReplies, 428)),
          estimatedDeliveryDate: getReplyValue(findReplyByQuestionId(blockReplies, 429)),
          estimatedStartDate: getReplyValue(findReplyByQuestionId(blockReplies, 430)),
          estimatedEndDate: getReplyValue(findReplyByQuestionId(blockReplies, 431)),
          invoicePlan: getReplyValue(findReplyByQuestionId(blockReplies, 432)),
          unbundled: getReplyValue(findReplyByQuestionId(blockReplies, 435)),
          total
        }
        servicesResult[blockIndex] = servicesData
      }
    })
    return Object.values(servicesResult)
  }
  const hardwareData = hardwareBlock()
  const softwareData = softwareBlock()
  const servicesData = servicesBlock()

  return (
    <>
      <Header />

      <Separator weight={30} />

      <Contacts />

      <Separator weight={20} />

      <Summaries hardwareData={hardwareData} softwareData={softwareData} servicesData={servicesData} />

      <Separator weight={30} />

      <PaymentSummary hardwareData={hardwareData} softwareData={softwareData} servicesData={servicesData} />

      <Separator weight={20} />

      <Pricing hardwareData={hardwareData} softwareData={softwareData} servicesData={servicesData} />

      <Separator weight={20} />

      <DeliverySchedules hardwareData={hardwareData} softwareData={softwareData} servicesData={servicesData} />

      <Separator weight={20} />

      <ShippingLocations />

      <Separator weight={20} />

      <PaymentDetails hardwareData={hardwareData} softwareData={softwareData} servicesData={servicesData} />

      <Footer />
    </>
  )
}

export default PropostaComercialPageContent
